import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { QRCodeSVG } from 'qrcode.react'
import { Screen } from '@/components/app/screen'
import { Skeleton } from '@/components/ui/skeleton'
import { useWakeLock } from '@/hooks/use-wake-lock'
import { apiGet } from '@/lib/api'

export const Route = createFileRoute('/_fidele/mon-qr/')({
  component: MyQrScreen,
})

interface MemberProfile {
  memberCode: string
  memberNumber: string
  firstName: string
  lastName: string
  qrCode: string
  organization: { name: string }
}

function MyQrScreen() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['member', 'me'],
    queryFn: () => apiGet<MemberProfile>('members/me'),
  })

  // Le fidèle présente son écran au placeur : il ne doit pas s'éteindre.
  useWakeLock(true)

  return (
    <Screen withTabBar className="flex flex-col items-center justify-center gap-6 px-6">
      {isPending && <Skeleton className="size-[276px] rounded-[20px] bg-navy-900" />}

      {isError && (
        <p className="text-center text-[14px] text-steel">
          Impossible de charger votre carte. Vérifiez votre connexion.
        </p>
      )}

      {data && (
        <>
          <div className="text-center">
            <p className="text-[11px] font-semibold tracking-[1.2px] text-gold uppercase">
              {data.organization.name}
            </p>
            <p className="mt-2 text-[22px] font-bold text-chalk">
              {data.firstName} {data.lastName}
            </p>
            <p className="mt-0.5 text-[13px] text-steel">{data.memberNumber}</p>
          </div>

          <div className="rounded-[20px] bg-white p-5 shadow-lg">
            <QRCodeSVG value={data.qrCode} size={220} bgColor="#ffffff" fgColor="#000000" />
          </div>

          <p className="max-w-[16rem] text-center text-[13px] leading-relaxed text-steel">
            Présentez ce code à l'entrée du culte. Montez la luminosité de votre écran si le scan
            échoue.
          </p>
        </>
      )}
    </Screen>
  )
}
